import React from 'react';
import { styled } from 'linaria/react';
import Image from '@jetshop/ui/Image/Image';
import { Above } from '@jetshop/ui/Breakpoints';
import { theme } from '../../Theme';
import { css, cx } from 'linaria';
import { Button } from '../../ui/Button';
import { cleanProps } from '../../../utils/HelpFunctions';

const StyledBoxRowItem = styled.div`
  border: ${({ outside }) => (!outside ? 'none' : '1px solid #eee')};
  align-self: ${({ outside }) => (!outside ? 'flex-start' : 'initial')};
  flex: ${({ doubleOnMobile }) => (doubleOnMobile ? '1 1 40%' : '1 1 100%')};
  ${theme.above.lg} {
    flex: 1;
  }

  h2 {
    line-height: 1.2;
  }
`;

const StyledBoxLink = styled.a`
  border: ${({ outside }) => (!outside ? 'none' : '1px solid #eee')};
  align-self: ${({ outside }) => (!outside ? 'flex-start' : 'initial')};
  flex: ${({ doubleOnMobile }) => (doubleOnMobile ? '1 1 40%' : '1 1 100%')};
  text-decoration: none;
  ${theme.above.lg} {
    flex: 1;
  }
`;

const baseBox = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`;

const Padded = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${theme.space.sm};
  gap: ${theme.space.xs};
  width: 100%;
`;

const absolute = css`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
`;

const imageWrapper = css`
  width: 100%;
`;

const titleStyle = css`
  font-weight: 500;
  font-size: calc(42rem / 16);
`;

function BoxRowItem({ rowAmount, doubleOnMobile, type, ...props }) {
  const clean = cleanProps(props);
  let {
    backgroundColor,
    buttonTheme,
    outside,
    color,
    verticalPosition,
    horizontalPosition,
    desktopImage,
    desktopImageAspect,
    mobileImage,
    mobileImageAspect,
    buttonText,
    preTitle,
    title,
    text,
    link,
    desktopBoxAspect,
    mobileBoxAspect
  } = clean;

  const flexMain = alignment => {
    switch (alignment) {
      case 'top':
        return 'flex-start';
      case 'middle':
        return 'center';
      case 'bottom':
        return 'flex-end';
      default:
        return 'center';
    }
  };

  const flexCross = alignment => {
    switch (alignment) {
      case 'left':
        return 'flex-start';
      case 'center':
        return 'center';
      case 'right':
        return 'flex-end';
      default:
        return 'center';
    }
  };

  const textAlign = alignment => {
    switch (alignment) {
      case 'left':
        return 'left';
      case 'center':
        return 'center';
      case 'right':
        return 'right';
      default:
        return 'center';
    }
  };

  function paddingFromRatio(ratio) {
    if (ratio) {
      const [width, height] = ratio.split(':').map(Number);
      return `${(height / width) * 100}%`;
    }
    return '100%';
  }

  console.log('TEXT:', !!(text && type === 'BoxRowItem'));
  return (
    <WrapperWithLink
      link={link}
      buttonExists={buttonText && buttonText !== ''}
      outside={outside}
      doubleOnMobile={doubleOnMobile}
      style={{ backgroundColor: backgroundColor || 'transparent' }}
    >
      {type === 'BoxRowItem' ? (
        <Above breakpoint="lg">
          {matches => (
            <div className={cx(imageWrapper)}>
              {matches ? (
                <Image
                  src={desktopImage}
                  sizes={[1, 1, 1 / 2, 1 / rowAmount]}
                  aspect={desktopImageAspect || desktopBoxAspect}
                  cover
                />
              ) : (
                <Image
                  src={mobileImage}
                  sizes={[1, 1, 1 / 2, 1 / 2]}
                  aspect={mobileImageAspect || mobileBoxAspect}
                  cover
                />
              )}
            </div>
          )}
        </Above>
      ) : (
        <Above breakpoint="lg">
          {matches =>
            matches ? (
              <div
                style={{ paddingBottom: paddingFromRatio(desktopBoxAspect) }}
              />
            ) : (
              <div
                style={{ paddingBottom: paddingFromRatio(mobileBoxAspect) }}
              />
            )
          }
        </Above>
      )}
      <Padded
        className={cx(!outside && absolute)}
        style={{
          color: color,
          justifyContent: flexMain(verticalPosition),
          alignItems: flexCross(horizontalPosition),
          textAlign: textAlign(horizontalPosition),
          maxWidth: type === 'BoxRowItem' ? 'initial' : 700,
          margin: '0 auto'
        }}
      >
        {preTitle && <p style={{ fontWeight: 700 }}>{preTitle}</p>}
        <h2 className={cx(type !== 'BoxRowItem' && titleStyle)}>{title}</h2>
        {type === 'BoxRowItem' ? (
          <>{text && <p>{text}</p>}</>
        ) : (
          <>{text && <p dangerouslySetInnerHTML={{ __html: text }} />}</>
        )}
        {buttonText && link && (
          <Button
            style={{ marginTop: type === 'BoxRowItem' ? 0 : theme.space.md }}
            secondary={buttonTheme?.includes('light')}
            outline={buttonTheme?.includes('outline')}
            link={link}
          >
            {buttonText}
          </Button>
        )}
      </Padded>
    </WrapperWithLink>
  );
}

function WrapperWithLink({
  link,
  buttonExists,
  outside,
  doubleOnMobile,
  style,
  children
}) {
  if (link && !buttonExists) {
    return (
      <StyledBoxLink
        href={link}
        className={cx(baseBox)}
        style={{ ...style }}
        outside={outside}
        doubleOnMobile={doubleOnMobile}
      >
        {children}
      </StyledBoxLink>
    );
  }
  return (
    <StyledBoxRowItem
      className={cx(baseBox)}
      style={{ ...style }}
      outside={outside}
      doubleOnMobile={doubleOnMobile}
    >
      {children}
    </StyledBoxRowItem>
  );
}

export default BoxRowItem;
